import React, { Component } from 'react';

class IconHide extends Component {
    render() {
        return (
            <svg xmlns="http://www.w3.org/2000/svg" width="19.959" height="19.959" viewBox="0 0 19.959 19.959"><path className="a" d="M42.927,43.959H25.032A1.032,1.032,0,0,1,24,42.927h0V25.032A1.032,1.032,0,0,1,25.032,24h6.882a1.032,1.032,0,1,1,0,2.065h-5.85v15.83h15.83v-5.85a1.032,1.032,0,0,1,2.065,0v6.882a1.032,1.032,0,0,1-1.032,1.032ZM31.854,29.635a1.032,1.032,0,0,0,1.032,1.032h6.268l1.032-1.032L39.154,28.6H32.886a1.032,1.032,0,0,0-1.032,1.032ZM38,25.012a1.032,1.032,0,0,0,0,1.46l3.163,3.163L38,32.8a1.032,1.032,0,0,0,1.46,1.46l3.893-3.893a1.032,1.032,0,0,0,0-1.46l-3.893-3.893A1.032,1.032,0,0,0,38,25.012Z" transform="translate(-24 -24)" fill="#818596" /></svg>
        );
    }
}

export default IconHide;